import { setLoading } from 'Container/App/action';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LmsFormActions } from './enum';
import { selectLmsFormData } from './selector';
import { LmsForm, LmsResponse } from './interface';
import { getlmsPayload } from './util/lmsSagaHelper';
import { Address } from '@vfde-sails/avc-core';
import { selectAddress } from 'Container/App/selector';
import { handleLmsResponse } from './action';
import { trackLMFormSubmit } from '../../util/tracking';
import { postLmFrom } from '../../util/api';

export function* submitLmsFormSaga () {
    const formData: LmsForm = yield select(selectLmsFormData);
    const address: Address = yield select(selectAddress);

    try {
        yield put(setLoading(true));

        const payload = getlmsPayload(formData, address);

        if (!payload) {
            throw new Error('Empty payload');
        }

        const response: LmsResponse = yield call(postLmFrom, payload);

        yield put(handleLmsResponse(response));
        yield put(setLoading(false));

        trackLMFormSubmit();
    } catch (error) {
        yield put(handleLmsResponse(error as any));
        yield put(setLoading(false));
    }
}

export default function* saga() {
    yield takeLatest(LmsFormActions.SUBMIT_LMS_FORM, submitLmsFormSaga);
}
